import { render, staticRenderFns } from "./Educators.vue?vue&type=template&id=590c7a90&"
import script from "./Educators.vue?vue&type=script&lang=js&"
export * from "./Educators.vue?vue&type=script&lang=js&"
import style0 from "./Educators.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports